<template>
    <div class="Title">
        <a>
            <slot/>
        </a>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                oldEl: null,
                container: null,
                oldTitle: null,
            }
        },
        mounted: function () {
            this.container = document.querySelector('.main-title');
            this.oldEl = this.container.firstElementChild;
            if (this.oldEl) {
                this.container.removeChild(this.oldEl);
            }
            this.container.append(this.$el);

            this.oldTitle = document.title;
            document.title = this.$el.textContent + ' – ' + document.title.split('–')[1];
        },

        destroyed: function () {
            if (this.container) {
                this.container.removeChild(this.$el);
            }
            if (this.oldEl) {
                this.container.append(this.oldEl);
            }
            this.oldEl = this.container = null;

            document.title = this.oldTitle;
        }

    };
</script>
